module.exports = __webpack_public_path__ + "static/media/pointing-down-hand.0d9ac8f2.svg";